import { Affiliate } from "../components/Affiliate";
import { AffiliateTop } from "../components/AffiliateTop";
import { Layout } from "../components/Layout";
export const AffiliatePage = () => {
  return (
    <Layout
      title="Do you have any queries?"
      action="Contact Us"
      hint="Schedule a meeting to address your queries and explore opportunities for collaboration."
      link="https://calendly.com/abdul-raheem-devsterlabs/30min"
    >
      <AffiliateTop />
      <Affiliate />
    </Layout>
  );
};
